import '@/utils/envHeader'
import Vue from "vue";

// 消除 Chrome 的 ResizeObserver 循环告警：把回调推迟到下一帧执行，
// 避免回调内触发布局变化后与同一帧的剩余通知形成循环（浏览器会抛出
// "ResizeObserver loop completed with undelivered notifications"）
const NativeResizeObserver = window.ResizeObserver
window.ResizeObserver = class extends NativeResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => callback(entries, observer))
    })
  }
}

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en"; // lang i18n

import "@/styles/index.scss"; // global css

import App from "./App";
import store from "./store";
import router from "./router";

import "@/icons"; // icon
import "@/permission"; // permission control
import moment from "moment"; //导入文件
Vue.prototype.$moment = moment; //赋值使用
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */

// 定义防抖指令
Vue.directive('debounce', {
  inserted: function (el, binding) {
    let [fn, event = "click", time = 300] = binding.value
    let timer
    el.addEventListener(event, () => {
      timer && clearTimeout(timer)
      timer = setTimeout(() => fn(), time)
    })
  }
})

// 会话空闲超时监控（滑动会话：用户有操作即重置计时，45分钟无操作自动退出；
// 后端token为24小时纯凭证，会话时长由这里唯一控制，2026-09-21 用户拍板30→45分钟）
import { removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
const IDLE_TIMEOUT = 45 * 60 * 1000
let idleTimer = null
function resetIdleTimer() {
  idleTimer && clearTimeout(idleTimer)
  idleTimer = setTimeout(idleLogout, IDLE_TIMEOUT)
}
function idleLogout() {
  removeToken()
  store.commit('user/RESET_STATE')
  Message.warning('会话已超时，请重新登录')
  router.push('/login')
  document.removeEventListener('mousemove', resetIdleTimer)
  document.removeEventListener('keydown', resetIdleTimer)
  document.removeEventListener('click', resetIdleTimer)
  document.removeEventListener('scroll', resetIdleTimer)
  document.removeEventListener('touchstart', resetIdleTimer)
}
document.addEventListener('mousemove', resetIdleTimer)
document.addEventListener('keydown', resetIdleTimer)
document.addEventListener('click', resetIdleTimer)
document.addEventListener('scroll', resetIdleTimer)
document.addEventListener('touchstart', resetIdleTimer)
resetIdleTimer()

if (process.env.NODE_ENV === "production") {
  const { mockXHR } = require("../mock");
  mockXHR();
}

// set ElementUI lang to EN
Vue.use(ElementUI, {
  locale
});
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});
